export type ThemeChoice = 'light' | 'dark';

const KEY = 'spese-theme';

export function getStoredTheme(): ThemeChoice | null {
  const t = localStorage.getItem(KEY);
  if (t === 'dark' || t === 'light') return t;
  return null;
}

export function applyTheme(t: ThemeChoice) {
  document.documentElement.setAttribute('data-theme', t);
  localStorage.setItem(KEY, t);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', t === 'dark' ? '#0c1426' : '#0369a1');
}

/** All’avvio app (dopo login) se non c’è preferenza salvata. */
export function ensureThemeApplied() {
  const t = getStoredTheme();
  if (t) applyTheme(t);
}
